@if (seenAnnouncements().length > 0) {
  <button
    type="button"
    class="btn btn-outline-primary me-1"
    [attr.aria-label]="'announcement.reset' | translate"
    [ngbTooltip]="'announcement.reset' | translate"
    placement="bottom"
    container="body"
    (click)="onResetSeenAnnouncements()"
  >
    <fa-icon [icon]="'bullhorn'"></fa-icon>
  </button>
}
